export const getLanguageFromStorage = () => {
  const languageFromStorage = localStorage.getItem('languageLocale');

  return JSON.parse(languageFromStorage as string)?.state?.selectedLanguage;
};
